module.exports = __webpack_public_path__ + "img/4.e2e6fd61.jpg";